/**
 * Roteador hash mínimo (#/rota). Sem dependências.
 * Cada rota tem um `render(container)` e flags de acesso.
 */
import { iniciarCarregamentoSecao } from '../ui/carregando.js';

const rotas = new Map();
let aoNavegar = null; // callback opcional chamado a cada navegação (rota)

/**
 * Registra uma rota.
 * @param {string} caminho - ex.: '/dashboard'.
 * @param {{render:(c:HTMLElement)=>void, gestor?:boolean, titulo?:string}} cfg
 */
export function rota(caminho, cfg) {
  rotas.set(caminho, cfg);
}

/** Navega para um caminho (atualiza o hash). */
export function ir(caminho) {
  if (location.hash !== '#' + caminho) location.hash = '#' + caminho;
  else resolver();
}

/** @returns {string} caminho atual a partir do hash. */
export function caminhoAtual() {
  return (location.hash || '#/').slice(1) || '/';
}

/** Define callback executado a cada resolução de rota (ex.: marcar item ativo). */
export function onNavegar(cb) {
  aoNavegar = cb;
}

/**
 * Inicia o roteador.
 * @param {(caminho:string)=>({render:Function}|null)} resolverAcesso
 *   função que recebe o caminho e devolve a config a renderizar (ou redireciona).
 */
export function iniciarRouter(resolverAcesso) {
  const handler = async () => {
    const caminho = caminhoAtual();
    const cfg = resolverAcesso(caminho);
    if (cfg && typeof cfg.render === 'function') {
      if (aoNavegar) aoNavegar(caminho);
      const container = document.getElementById('view') || document.getElementById('app');
      const pararCarregamento = iniciarCarregamentoSecao(); // overlay branded enquanto a secao carrega (atraso evita flash)
      try { await cfg.render(container); }
      catch (e) { console.error('[rota]', e); }
      finally { pararCarregamento(); }
    }
  };
  window.addEventListener('hashchange', handler);
  handler();
}

/** Acesso interno ao mapa de rotas (usado pelo resolvedor de acesso em main.js). */
export function obterRota(caminho) {
  return rotas.get(caminho) || null;
}

function resolver() {
  window.dispatchEvent(new HashChangeEvent('hashchange'));
}
